import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SituationFamiliale } from 'src/app/shared/models/situationFamiliale';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class SituationFamilialeService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllSituationFamiliale(): Observable<SituationFamiliale[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.situationFamilialeUrl}/all`,
			'getAllSituationFamiliale'
		);
	}

	importSituationFamiliale(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'situationFamiliale.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.situationFamilialeUrl}/import`,
			`importSituationFamiliale`,
			formData
		);
	}

	getSituationFamilialeById(id: number): Observable<SituationFamiliale> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.situationFamilialeUrl}/get/${id}`,
			'getSituationFamilialeById'
		);
	}

	updateSituationFamiliale(situationFamiliale: SituationFamiliale): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.situationFamilialeUrl}/update/${situationFamiliale.id}`,
			'updateSituationFamiliale',
			situationFamiliale
		);
	}

	addSituationFamiliale(situationFamiliale: SituationFamiliale): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.situationFamilialeUrl}/add`,
			'addSituationFamiliale',
			situationFamiliale
		);
	}

	deleteSituationFamiliale(situationFamilialeId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.situationFamilialeUrl}/delete/${situationFamilialeId}`,
			`deleteSituationFamiliale`
		);
	}
}
